module.exports = __webpack_public_path__ + "img/chart.ebf3dfff.png";